import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ModalEnquiry from './ModalEnquiry';

export default function Hero() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <section
      id="hero-section"
      className="min-h-screen flex flex-col justify-center items-center relative text-center pt-24 overflow-hidden"
      style={{ backgroundColor: 'var(--bg)' }}
    >
      <div className="hero-line-grid" />
      <div className="ai-orb w-[420px] h-[420px] -top-32 -left-32" />
      <div className="ai-orb w-[360px] h-[360px] bottom-0 -right-24" style={{ animationDelay: '4s' }} />

      <div className="container-premium relative z-10 flex flex-col items-center animate-fade-in-up">
        <h1 className="t-display md:text-5xl font-display mb-6" style={{ color: 'var(--text-primary)' }}>
          Ufeus Consultancy Service Pvt Ltd
        </h1>
        <div className="eyebrow mb-6">Software &amp; AI Consultancy</div>

        <motion.h2
          className="t-display md:text-6xl font-display mb-6 max-w-4xl"
          style={{ color: 'var(--text-primary)' }}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          Minimal Code. <span className="text-shimmer">Maximum Impact.</span><br />
          Powered by AI.
        </motion.h2>

        <motion.p
          className="t-h3 font-normal max-w-2xl mb-10"
          style={{ color: 'var(--text-secondary)' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          We design and build enterprise software using vibe coding, prompt engineering &amp; applied AI — engineered by a team that has shipped systems for over two decades.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.55 }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <button className="btn btn-primary" onClick={() => setModalOpen(true)}>
            Talk to Us
          </button>
          <a href="#build" className="btn btn-secondary">
            See What We Build
          </a>
        </motion.div>
      </div>

      <ModalEnquiry open={modalOpen} onClose={() => setModalOpen(false)} triggerLabel="Talk to Us" />
    </section>
  );
}
